import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSurvey from './survey.reducer';

export const selectSurveyState = createFeatureSelector<fromSurvey.State>(
  fromSurvey.surveyFeatureKey
);
export const selectSurveyRecordState = createFeatureSelector<fromSurvey.State>(
  fromSurvey.surveyFeatureKey
);


export const selectSurveyShow = createSelector(
  selectSurveyState,
  (state: fromSurvey.State) => {
    return state.show;
  },
);

export const selectSurveyRecord = createSelector(
  selectSurveyRecordState,
  (state: fromSurvey.State) => {
    return state.record;
  }

);




